<script>
  import Breadcrumbs from '$components/Breadcrumbs/Breadcrumbs.svelte';
  import MastheadSearchPromo from '$components/MastheadSearchPromo/MastheadSearchPromo.svelte';
  import LocationLinkList from '$components/LocationLinkList/LocationLinkList.svelte';
  import DrugSavingsList from '$components/DrugSavingsList/DrugSavingsList.svelte';
  import ExtendedPharmaciesList from '$components/ExtendedPharmaciesList/ExtendedPharmaciesList.svelte';

  let { data } = $props();
</script>

<svelte:head>
  <link rel="preconnect" href="https://ik.imagekit.io/" />
  {#if data.mastheadSearchPromo && data.mastheadSearchPromo.backgroundImage}
    <link rel="preload" as="image" href={data.mastheadSearchPromo.backgroundImage.url} />
  {/if}
</svelte:head>

<Breadcrumbs crumbsText={data.crumbsText} path={data.path} />
<MastheadSearchPromo {...data.mastheadSearchPromo} lang={data.lang} />
<div class="py-6 md:py-8 mx-auto max-w-6xl lg:flex">
  <LocationLinkList {...data.locationLinkList} locations={data.locations} pageGroup='pharmacy-near-me-chain'/>
</div>
<div class="px-4 pb-6 md:pb-8 mx-auto max-w-6xl">
  <DrugSavingsList {...data.drugSavingsList} lang={data.lang} />
</div>
<div class="bg-gray-mercury w-full py-8 lg:py-12 shadow-content-well">
  <ExtendedPharmaciesList {...data.extendedPharmaciesList} pharmacies={data.pharmacies} />
</div>
